import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import { WMSOrderFiltersType } from "../type/WMSOrderFiltersType";

export const ORDER_FIELDS = `
    id
    securityRnd
    trackingNumber
    externalTrackingNumber
    channelId
    channelOrderNumber
    orderTime
    overallStatus
    isDelivered
    isIntercepted
    isAbnormal
    exceptionStatus
    isHasBeenSetException
    expectedDeliveryTime
    deliveredAt
    lastDeliveryScanTime
    deliveryAttempts
    exceptionReasonCode
    markExceptionAt
    nextAction
    isHasBeenSetException
    senderAddressId
    recipientAddressId
    receiverZipcode
    sortingCode
    weightKg
    volumetricWeightKg
    lengthCm
    widthCm
    heightCm
    packageValueUsd
    podReviewStatus
    podImageS3KeysJson
    podImageS3UrlsJson
    exceptionImageS3KeysJson
    exceptionImageS3UrlsJson
    nextAction
    isDestHubArrived
    isDestWarehouseArrived
    destHubArrivedAt
    destWarehouseArrivedAt
    receivedAtHub
    deliverAt
    isComplaint
    hasManded
    isFinished
    createdAt
    updatedAt
    lastBagTaskId
    bagTaskNumber
    prePickupHubName
    pickupHubName
    deliveredDspId
    lastScannedDriverName
    lastAssignedDriverName
    returnArrivalHubAt
`;



export const GET_ORDER_LISTING_FOR_WMS = gql`
    query WmsParcelsQuery($filters: WmsParcelFiltersTypeInput!,
                       $pageRequest: PageRequestTypeInput) {
        getOrderListingForWMS(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export interface WMSOrderListResponse {
    getOrderListingForWMS: WMSOrderListingResponseType;
}

export interface WMSOrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    accessiblePages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface GetOrderListingForWMSInput {
    filters?: WMSOrderFiltersType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}
